import { css, type Theme } from "@emotion/react";

export const wrapper = (theme: Theme) => css`
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: ${theme.system.backgroundMuted};
`;

export const link = (theme: Theme) => css`
  color: ${theme.system.textBase};
  text-decoration: underline;
  :hover {
    color: ${theme.system.textBase};
  }
`;
